import React from "react";
import { Box, Typography } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import OverviewStatCard from "./common/OverviewStatCard";
import StatItemCard from "./common/StatItemCard";

export default function CreditUtilization({ overall, cards = [] }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.default",
      }}
    >
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <CreditCardIcon color="primary" />
          <Typography variant="h6" fontWeight="bold">
            Credit Card Utilization
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Overview of total and per-card utilization
        </Typography>
      </Box>

      <OverviewStatCard
        icon={<CreditCardIcon color="primary" />}
        title="Overview"
        subtitle=""
        metricLabel="Overall Utilization"
        metricValue={`${overall?.utilization ?? 0}% utilization`}
        progress={overall?.utilization ?? 0}
        detail={`$${(overall?.used ?? 0).toLocaleString()} used of $${(overall?.limit ?? 0).toLocaleString()} total limit`}
      />

      {cards.map((card, idx) => (
        <StatItemCard
          key={idx}
          title={card.name}
          subtitle={card.masked}
          progressLabel={`${card.utilization ?? 0}% utilization`}
          progressValue={card.utilization ?? 0}
          topRows={[
            { label: "APR", value: card.apr },
            {
              label: "Usage",
              value: `$${(card.used ?? 0).toLocaleString()} of $${(card.limit ?? 0).toLocaleString()} limit`,
            },
          ]}
          bottomRows={card.bottomRows || []}
        />
      ))}
    </Box>
  );
}
